import soporteTi from '../../../assets/img/formacion-tecnico-laboral/asistencia-soporte-ti.jpeg';
import seguridadTrabajo from '../../../assets/img/formacion-tecnico-laboral/seguridad-trabajo.jpeg';
import asistenteAdministrativo from '../../../assets/img/formacion-tecnico-laboral/asistente-administrativo.jpeg';
import primeraInfancia from '../../../assets/img/formacion-tecnico-laboral/primera-infancia.jpeg';
import artesGraficas from '../../../assets/img/formacion-tecnico-laboral/artes-graficas.jpeg';
import contableFinanciero from '../../../assets/img/formacion-tecnico-laboral/contable-financiero.jpeg';
import talentoHumano from '../../../assets/img/formacion-tecnico-laboral/talento-humano.jpeg';

// Duración, modalidad, jornadas y requisitos coinciden en las fichas oficiales consultadas.
const informacionComun = [
  {
    titulo: 'Duración',
    icono: '◷',
    texto: '1 año y medio (3 semestres académicos y un periodo de práctica)',
  },
  {
    titulo: 'Modalidad',
    icono: '▤',
    texto: 'Presencial',
  },
  {
    titulo: 'Jornadas',
    icono: '▦',
    elementos: [
      'Sábados de 07:00 a. m. a 12:30 p. m.',
      'Sábados de 01:00 p. m. a 06:00 p. m.',
      '1 día a la semana (de acuerdo al número de estudiantes inscritos)',
    ],
  },
  {
    titulo: 'Requisitos',
    icono: '☑',
    elementos: [
      'Documento de identidad',
      'Diploma y acta de bachiller',
      'Estudiantes de noveno grado: certificado de estudios',
      'Certificado EPS',
      '2 Fotos 3*4 tipos de carnet (fondo blanco)',
    ],
  },
];

const programas = [
  {
    slug: 'asistencia-soporte-tecnologia-informacion',
    titulo: 'Asistencia y Soporte de Tecnología de la Información',
    nombreCorto: 'Asistencia y soporte de TI',
    imagen: soporteTi,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo de la tecnología de la información. Únete a nosotros y da el primer paso hacia una carrera exitosa en asistencia y soporte tecnológico. El programa está diseñado para formar profesionales competentes en la administración y soporte de sistemas tecnológicos.',
    informacion: informacionComun,
  },
  {
    slug: 'auxiliar-seguridad-trabajo',
    titulo: 'Auxiliar de Seguridad en el Trabajo',
    nombreCorto: 'Seguridad en el trabajo',
    imagen: seguridadTrabajo,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo de la seguridad y salud en el trabajo. Únete a nosotros y da el primer paso hacia una carrera exitosa en la gestión de la seguridad y salud laboral. El programa está diseñado para formar profesionales competentes en la identificación y control de riesgos laborales.',
    informacion: informacionComun,
  },
  {
    slug: 'asistente-administrativo',
    titulo: 'Asistente Administrativo',
    nombreCorto: 'Asistente administrativo',
    imagen: asistenteAdministrativo,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo empresarial actual. Únete a nosotros y da el primer paso hacia una carrera exitosa en administración. Está diseñada para formar profesionales competentes en la gestión eficiente de recursos y procesos administrativos. A lo largo del programa, los participantes desarrollarán habilidades en áreas claves.',
    informacion: informacionComun,
  },
  {
    slug: 'atencion-integral-primera-infancia',
    titulo: 'Atención Integral a la Primera Infancia',
    nombreCorto: 'Atención a la primera infancia',
    imagen: primeraInfancia,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo de la atención integral a la primera infancia. Únete a nosotros y da el primer paso hacia una carrera exitosa en el cuidado y desarrollo de los niños en su primera infancia. El programa está diseñado para formar profesionales competentes en la gestión y promoción del bienestar infantil.',
    informacion: informacionComun,
  },
  {
    slug: 'auxiliar-artes-graficas',
    titulo: 'Auxiliar de Artes Gráficas',
    nombreCorto: 'Artes gráficas',
    imagen: artesGraficas,
    conoceMas: '',
    informacion: informacionComun,
  },
  {
    slug: 'auxiliar-contable-financiero',
    titulo: 'Auxiliar Contable y Financiero',
    nombreCorto: 'Contable y financiero',
    imagen: contableFinanciero,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo contable y financiero. Únete a nosotros y da el primer paso hacia una carrera exitosa en contabilidad y finanzas. El programa está diseñado para formar profesionales competentes en la administración y gestión de recursos financieros.',
    informacion: informacionComun,
  },
  {
    slug: 'auxiliar-talento-humano',
    titulo: 'Auxiliar en Talento Humano',
    nombreCorto: 'Talento humano',
    imagen: talentoHumano,
    conoceMas: 'Nuestro enfoque práctico y teórico garantiza que los estudiantes estén preparados para enfrentar los desafíos del mundo de la gestión del talento humano. Únete a nosotros y da el primer paso hacia una carrera exitosa en la gestión de recursos humanos. El programa está diseñado para formar profesionales competentes en la administración y desarrollo del talento humano en las organizaciones.',
    informacion: informacionComun,
  },
];

export default programas;
